// Application Shell
import {Shell} from '@/entryPoints/b2c/shell';
import router from '@/projectOne/router';
import ProjectOneApp from '@/projectOne/ProjectOneApp';

// Vue Plugins
import tippy from 'vue-tippy';

// Styling
import '@sassRoot/entryPoints/b2c/project-one.scss';

class ProjectOne extends Shell {
  loadPlugins() {
    super.loadPlugins();
    this.loadTippy();
  }

  loadTippy() {
    this.vue.use(tippy, {
      animateFill: false,
      arrow: true,
      theme: 'light',
      flipDuration: 0,
      flip: true,
      flipBehavior: ['top', 'right', 'bottom'],
      popperOptions: {
        modifiers: {
          preventOverflow: {
            enabled: true,
          },
        },
      },
    });
  }
}

const projectOne = new ProjectOne({ProjectOneApp}, router);

projectOne.preLoadInits();
projectOne.initializeVue();

// Legacy foundation initialization
$(document).foundation();

$(document).ready(() => {
  projectOne.globalDocumentReadyInits();
});

$(window).on('load', () => {
  projectOne.globalOnLoadInits();
});
